import CustomField from "components/form/CustomField";
import SingleSelect from "components/common/SingleSelect";
import { Form, Formik } from "formik";
import { handleSubmitForm } from "helpers/apiUtils";
import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "store/slices/alertSlice";
import { editProfile, getDetails } from "store/slices/authSlice";
import { editProfileSchema } from "utils/validations";

const COUNTRY_CODE_OPTIONS = [{ name: "+966", value: "+966" }];

function EditProfile({ onCancel = () => {}, onSuccess = () => {} }) {
  const { t } = useTranslation();

  const { loading, isLoading, authUserDetails, rolePermissions } = useSelector(
    (state) => state.Auth,
  );
  const dispatch = useDispatch();
  const handleSubmitEditProfile = (values) => {
    const payload = {
      name: values.name,
      phoneCode: values.phoneCode,
      phoneNumber: values.phoneNumber,
    };
    handleSubmitForm({
      dispatch,
      action: editProfile,
      payload,
      onSuccess: () => {
        onSuccess();
        dispatch(getDetails());
        dispatch(
          showAlert({
            text: t(`Profile updated successfully`),
            type: "success",
          }),
        );
      },
    });
  };
  const [initialValues, setInitialValues] = useState({
    name: "",
    phoneCode: "+966",
    phoneNumber: "",
  });
  useEffect(() => {
    if (authUserDetails) {
      const { name, phoneCode, phoneNumber } = authUserDetails || {};
      setInitialValues({
        name,
        phoneCode: phoneCode || "+966",
        phoneNumber,
      });
    }
  }, [authUserDetails]);
  return (
    <div className="edit_profile_modal">
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={editProfileSchema(t)}
        onSubmit={handleSubmitEditProfile}
      >
        {({ values, errors, touched, setFieldValue }) => (
          <Form>
            <Col lg={12}>
              <div className="form_field">
                <CustomField
                  label={t("Name")}
                  name="name"
                  placeholder={t("Enter name")}
                  required
                />
              </div>
            </Col>

            <Col lg={12}>
              <div className="d-flex gap-2">
                <div className="form_field">
                  <label>
                    {t("Country Code")}
                    <span className="text-danger"></span>
                  </label>
                  <SingleSelect
                    value={values.phoneCode}
                    options={COUNTRY_CODE_OPTIONS}
                    handleSingleSelectChange={(e) =>
                      setFieldValue("phoneCode", e.value)
                    }
                    error={
                      errors.phoneCode && touched.phoneCode
                        ? errors.phoneCode
                        : null
                    }
                    placeholder={t("Select option")}
                  />
                </div>
                <div className="form_field w-100">
                  <CustomField
                    label={t("Phone Number")}
                    name="phoneNumber"
                    placeholder={t("Phone number placeholder")}
                    required
                  />
                </div>
              </div>
            </Col>

            <button
              type="submit"
              className="main_btn w-100 mt-3"
              disabled={isLoading}
            >
              {isLoading ? t("Submitting...") : t("Submit")}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default EditProfile;
